import { sets } from 'abis/set/sets'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import React, { useState } from 'react'
import { extractTransactionDetails, getIcon, textSwitch } from '../../controller'
import {
  AssetIconWrapper,
  PendingItemWrapper,
  StyledLeftColumn,
  StyledTXText,
  TextAndSubText,
} from '../../style'
import ChainStatusContainer from './chain-statuses'
import TransactionText from './transaction-text'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import { Transaction } from 'services'

const TransactionItem: React.FC<{ transaction: Transaction }> = ({ transaction }) => {
  const [transactionFailed, setTransactionFailed] = useState<boolean>(false)
  const [completedTransactions, setCompletedTransactions] = useState<number>(0)
  const [successfulTransactions, setSuccessfulTransactions] = useState<number>(0)
  const [totalTransactions, setTotalTransactions] = useState<number>(0)
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.WalletManagement)
  const exploreTransaction = () => {
    const hash = transaction.replacementHash ? transaction.replacementHash : transaction.hash
    return navigationEvent(`${sets[transaction.action.network].blockExplorer}/tx/${hash}`, true)
  }
  const transactionDetails = extractTransactionDetails(transaction)
  const icon = getIcon(transactionDetails)
  /**
   * IT: Updates the completed transactions and failed transactions
   * WHEN: status changes
   */
  React.useEffect(() => {
    const multiTxs = transaction.additionalTransactions
    if (multiTxs) {
      const remoteCompleted = multiTxs.filter(
        ({ status }) =>
          status === (TransactionStatus.DELIVERED || status === TransactionStatus.FAILED),
      ).length
      const homeToRemoteSuccessful = multiTxs.filter(
        ({ status }) => status === TransactionStatus.DELIVERED,
      ).length
      setSuccessfulTransactions(homeToRemoteSuccessful)
      setTotalTransactions(
        transaction.additionalChains && transaction.additionalChains.length !== 0
          ? transaction.additionalChains.length + 1
          : multiTxs.length,
      )
      setCompletedTransactions(remoteCompleted)
      const remoteFailed =
        multiTxs.some(({ status }) => status === TransactionStatus.FAILED) &&
        multiTxs.every(({ status }) => status !== TransactionStatus.INFLIGHT)
      setTransactionFailed(remoteFailed)
    }
  }, [transaction])

  return (
    <PendingItemWrapper failed={transactionFailed}>
      <StyledLeftColumn>
        <AssetIconWrapper src={icon} />
        <TextAndSubText>
          <StyledTXText onClick={exploreTransaction}>{textSwitch(transactionDetails)}</StyledTXText>
          {totalTransactions > 0 && (
            <TransactionText
              completedTransactions={completedTransactions}
              totalTransactions={totalTransactions}
              transactionFailed={transactionFailed}
              successfulTransactions={successfulTransactions}
            />
          )}
        </TextAndSubText>
      </StyledLeftColumn>
      <ChainStatusContainer
        transactions={transaction.additionalTransactions?.filter((el) => el.chain) || []}
      />
    </PendingItemWrapper>
  )
}

export default TransactionItem
